<drop-down
    #dropDown
    [selectedTemplate]="selectedTemplate"
    [optionsTemplate]="optionsTemplate"
    (optionsVisibility)="onOptionsToggle($event)"
    (contentRender)="onRender($event)"
    [class.ng-invalid]="!valid"
    [disabled]="disabled"
>
    <ng-template #selectedTemplate>
        <div class="picker-result">
            <div class="selected-wrapper">
                <span *ngIf="!selected.size">{{ emptyPlaceholderText }}</span>
                <span *ngIf="selected.size && isAllSelected(); else outputTemplate">{{ fullPlaceholderText }}</span>
                <ng-template #outputTemplate>
                    <enum-output #enumOutput [enumData]="getLabels()" [restStringFn]="restStringFn"></enum-output>
                </ng-template>
            </div>
            <button type="button" class="clear-btn" *ngIf="selected.size" (click)="onClear($event)" [disabled]="disabled"></button>
        </div>
    </ng-template>
    <ng-template #optionsTemplate>
        <div class="tree-wrapper" #treeWrapper>
            <div class="drop-down-toggle" (click)="dropDown.toggleContent(false)">
                <ng-container [ngTemplateOutlet]="selectedTemplate"></ng-container>
            </div>
            <div class="search-wrapper" *ngIf="options.length">
                <search-input
                    #searchInput
                    [placeholder]="searchPlaceholder"
                    [(ngModel)]="searchQuery"
                    (searchInput)="onSearch()"
                ></search-input>
            </div>
            <checkbox-tree
                #treeComponent
                [nodes]="options"
                [selected]="selected"
                [presets]="presets"
                [selectAllPreset]="selectAllPreset"
                [filterQuery]="searchQuery"
                [noResultsPlaceholder]="noResultsPlaceholder"
                (expand)="onExpand()"
                (selectedChange)="invokeChangeCallback(selected, true)"
            ></checkbox-tree>
        </div>
    </ng-template>
</drop-down>
